import type { FaireProductEntity } from "../../entity_types/product";

export const p_zeh3zwrcye: FaireProductEntity = {
  token: "p_zeh3zwrcye",
  type: "product",
  name: "Teakwood & Tobacco– Air Freshener",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl: "https://cdn.faire.com/fastly/3676005b8a2bb891969ca1a3529b632d5578b4d2b8ebafd20d9235ad089c8e0c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6ea6378f5bd68c3b07a966328a8e312c89f52a9d044e58570b28a2b3d2ccf59e.jpeg",
    "https://cdn.faire.com/fastly/09a51c691ca3aefaf4590c7f2f4c45b2480cfd8b8fbf91f24a01f88c28b62e78.jpeg",
    "https://cdn.faire.com/fastly/661d8f6a1c8ea9227a1d1b5f5f17b51f168a251b1399e9f59872bb8a0440db30.jpeg",
    "https://cdn.faire.com/fastly/86edcb8854439d810696d47c2462d1190e8f64c20dd9f602f9ce4f70524157ad.jpeg"
  ],
  priceDollars: 5.5,
  description: "The one that started it all. Some call it the boyfriend scent, we call it the O.G. Leather, teak, and orange.\n\nAir Fresheners are a flame-free collection designed to scent small spaces, like closets, bathrooms, gym lockers, trash cans, hotel rooms, and anywhere else that needs a little fragrance boost. \n\nThey are pre-packed in pairs, featuring an iconic P.F. Candle-shape and signature kraft paper look. Available in 8 best-selling Classic Line scents. ",
  tags: [],
  msrpDollars: 11.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:47.751Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
